var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
OCS.Interfaces.Utilities = OCS.Interfaces.Utilities || {};
OCS.Interfaces.Utilities.object = {
    object_keys: function (object) {
        var keys = [];
        for (var k in object)
            keys.push(k);
        return keys;
    },
    clone_object: function (in_obj, prop_keys) {
        // in_obj: The object to be cloned
        // prop_keys: the properties to clone off of for an object
        var new_obj = {};
        var local_defined_keys = false;
        if (in_obj instanceof Array) {
            new_obj = [];
            var array_size = in_obj.length;
            for (var i = 0; i < array_size; i++) {
                new_obj.push(in_obj[i]);
            }
            return new_obj;
        }
        if (in_obj === null || typeof (in_obj) != 'object') {
            return in_obj;
        }

        if (!prop_keys) {
            // In the event we are not passed specific keys we will use the keys from the incoming object
            prop_keys = Object.keys(in_obj);
            local_defined_keys = true;
        }

        Object.each(prop_keys, function (key) {
            if (key in in_obj) {
                if (local_defined_keys) {
                    new_obj[key] = this.clone_object(in_obj[key]);
                } else {
                    new_obj[key] = this.clone_object(in_obj[key], prop_keys);
                }

            }
        }.bind(this));
        return new_obj;


    },
    /**
     * 
     * @param {Object} object_a - Object to merge onto by B.
     * @param {Object} object_b - Object being merged over A.
     * @param {Object} ops - Optional A set of options for the merge.
     * @param {Boolean} ops.deep - Optional Set the merge to dig deep through multiple levels of objects
     * @param {Boolean} ops.merge - Optional Sets arrays to be merged instead of combined.
     * @param {Boolean} ops.remove - Optional Sets arrays to be merged instead of combined.
     * @param {Boolean} ops.merge_mismatch - Optional forces a merge mismatch to be object_b value.
     * @returns {OCS.Interfaces.Utilities.object.combine_objects.object_c}
     */
    combine_objects: function (object_a, object_b, ops) {
        var object_c = {};
        var obj_a_keys, obj_b_keys;
        if (!ops) {
            ops = {};
        }
        if (ops && ops.deep) {
            obj_a_keys = this.object_keys(object_a);
            obj_b_keys = this.object_keys(object_b);
        } else {
            obj_a_keys = Object.keys(object_a);
            obj_b_keys = Object.keys(object_b);
        }
        var i, j, key;
        for (i = 0; i < obj_a_keys.length; i++) {
            key = obj_a_keys[i];
            if (key in object_b && !this.is_null(object_b[key]) && !this.is_undefined(object_b[key])) {

                if (this.is_null(object_a[key]) || this.is_undefined(object_a[key])) {
                    // Since object_a has the key defined but has an undefined value and 
                    //    object_b has a defined key and value, use the object_b value;
                    object_c[key] = object_b[key];
                    continue;
                }
                if (this.isNumber(object_a[key]) && this.isNumber(object_b[key])) {
                    object_c[key] = object_b[key];
                    continue;
                }

                if (typeof (object_a[key]) !== typeof (object_b[key]) && !ops.merge_mismatch) {
                    object_c[key] = [];
                    object_c[key].push(object_a[key]);
                    object_c[key].push(object_b[key]);
                    console.warn('Utilities - combine object: Object type mismatch with key ' + key + '!', object_a[key], object_b[key]);
                    continue;
                }
                if (object_a[key] instanceof Array && object_b[key] instanceof Array) {
                    if (!this.is_array_equal(object_a[key], object_b[key])) {
                        if (ops && ops.merge) {
                            object_c[key] = [];
                            for (j = 0; j < object_b[key].length; j++) {
                                object_c[key][j] = object_b[key][j];
                            }
                            for (j; j < object_a[key].length; j++) {
                                object_c[key][j] = object_a[key][j];
                            }
                        } else {
                            object_c[key] = object_a[key].concat(object_b[key]);
                        }
                    } else {
                        if (ops && ops.merge) {
                            object_c[key] = object_a[key];
                        } else {
                            object_c[key] = object_a[key].append(object_b[key]);
                        }
                    }
                    continue;
                }
                if (typeof (object_a[key]) === 'object' && typeof (object_b[key]) === 'object') {
                    object_c[key] = this.combine_objects(object_a[key], object_b[key], ops);
                    continue;
                }

            } else {
                if (ops && ops.remove && this.is_null(object_b[key])) {
                    continue;
                } else {
                    object_c[key] = object_a[key];
                }
            }
        }
        for (i = 0; i < obj_b_keys.length; i++) {
            key = obj_b_keys[i];
            if (!object_c.hasOwnProperty(key) && !this.is_null(object_b[key]) && !this.is_undefined(object_b[key])) {
                object_c[key] = object_b[key];
            }
        }
        return object_c;
    },
    is_object_equal: function (object_a, object_b, ops) {
        if (!this.is_null(object_a) && !this.is_null(object_b) && this.is_object(object_a) && this.is_object(object_b)) {
            if (Object.keys(object_a).length === Object.keys(object_b).length) {
                var result = this.get_object_diff(object_a, object_b);
                if (!Object.keys(result).length) {
                    return true;
                }
            }
        }
        return false;
    },
    get_object_diff: function (prev, now) {
        var changes = {};
        var prop = {};
        var c = {};
        //-----

        for (prop in now) { //ignore jslint
            /* istanbul ignore if */
            if (prop.indexOf("_KO") > -1) {
                continue; //ignore jslint
            }
            /* istanbul ignore if */
            if (!prev || prev[prop] !== now[prop]) {
                if (typeOf(now[prop]) === 'array') {
                    if (typeOf(prev[prop]) === 'array' && this.is_array_equal(prev[prop], now[prop])) {
                        continue;
                    }

                    changes[prop] = now[prop];
                } else if (typeof now[prop] === 'object') {
                    // Recursion alert
                    c = this.get_object_diff(prev[prop], now[prop]);
                    if (Object.keys(c).length) {
                        changes[prop] = c;
                    }
                } else {
                    changes[prop] = now[prop];
                }
            }
        }

        return changes;
    },
    object_has_object_with_cond: function (object, conditional_callback) {
        var i, key;
        var keys = Object.keys(object);
        if (keys.length) {
            // Loop through every element of the array to determine if the condition passes
            for (i = 0; i < keys.length; i++) {
                key = keys[i];
                if (conditional_callback(object[key], key)) {
                    return key;
                }
            }
        }
        return false;
    },
    object_has_object_with_prop: function (object, conditions) {
        var i, key;
        var condition_keys = this.object_keys(conditions);
        var object_keys = this.object_keys(object);
        var result = false;
        if (condition_keys.length && object_keys.length) {
            result = true;
            // Loop through every element of the array to determine if the condition passes
            for (i = 0; i < condition_keys.length; i++) {
                key = condition_keys[i];
                if (key in object && typeof conditions[key] === typeof object[key]) {
                    // Key is in Object and of the same type
                    if (this.is_string(conditions[key]) || this.isNumber(conditions[key]) || this.is_boolean(conditions[key])) {
                        if (object[key] !== conditions[key]) {
                            return false;
                        }
                    } else if (this.is_array(conditions[key])) {
                        if (!this.is_array_equal(conditions[key], object[key])) {
                            return false;
                        }
                    } else if (this.is_object(conditions[key])) {
                        if (!this.object_has_object_with_prop(object[key], conditions[key])) {
                            return false;
                        }
                    /* istanbul ignore if */
                    } else if (object[key] !== conditions[key]) {
                        return false;
                    }
                } else {
                    return false;
                }
            }
        }
        return result;
    },
    getWindBarbLevel: function (speed) {
        var level = 1;

        if (speed >= 5 && speed < 10) {
            level = 2;
        } else if (speed >= 10 && speed < 15) {
            level = 3;
        } else if (speed >= 15 && speed < 20) {
            level = 4;
        } else if (speed >= 20 && speed < 25) {
            level = 5;
        } else if (speed >= 25 && speed < 30) {
            level = 6;
        } else if (speed >= 30 && speed < 35) {
            level = 7;
        } else if (speed >= 35 && speed < 40) {
            level = 8;
        } else if (speed >= 40 && speed < 45) {
            level = 9;
        } else if (speed >= 45 && speed < 50) {
            level = 10;
        } else if (speed >= 50 && speed < 55) {
            level = 11;
        }
        return level;
    },
    degtodir: function (inWdirDeg) {
        var direction = '';

        if (inWdirDeg >= 0 && inWdirDeg < 11.25) {
            direction = "N";
        } else if (inWdirDeg >= 11.25 && inWdirDeg < 33.75) {
            direction = "NNE";
        } else if (inWdirDeg >= 33.75 && inWdirDeg < 56.75) {
            direction = "NE";
        } else if (inWdirDeg >= 56.25 && inWdirDeg < 78.75) {
            direction = "ENE";
        } else if (inWdirDeg >= 78.75 && inWdirDeg < 101.25) {
            direction = "E";
        } else if (inWdirDeg >= 101.25 && inWdirDeg < 123.75) {
            direction = "ESE";
        } else if (inWdirDeg >= 123.75 && inWdirDeg < 146.25) {
            direction = "SE";
        } else if (inWdirDeg >= 146.25 && inWdirDeg < 168.75) {
            direction = "SSE";
        } else if (inWdirDeg >= 168.75 && inWdirDeg < 191.25) {
            direction = "S";
        } else if (inWdirDeg >= 191.25 && inWdirDeg < 213.75) {
            direction = "SSW";
        } else if (inWdirDeg >= 213.75 && inWdirDeg < 236.25) {
            direction = "SW";
        } else if (inWdirDeg >= 236.25 && inWdirDeg < 258.75) {
            direction = "WSW";
        } else if (inWdirDeg >= 258.75 && inWdirDeg < 281.25) {
            direction = "W";
        } else if (inWdirDeg >= 281.25 && inWdirDeg < 303.75) {
            direction = "WNW";
        } else if (inWdirDeg >= 303.75 && inWdirDeg < 326.25) {
            direction = "NW";
        } else if (inWdirDeg >= 326.25 && inWdirDeg < 349.75) {
            direction = "NNW";
        } else if (inWdirDeg >= 349.75 && inWdirDeg <= 360) {
            direction = "N";
        } else {
            direction = this.degtodir(inWdirDeg - 360);
        }
        return direction;
    }
};